var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3001 3.59999C13.3001 5.42253 11.8226 6.89999 10.0001 6.89999C8.17755 6.89999 6.70009 5.42253 6.70009 3.59999C6.70009 1.77745 8.17755 0.299988 10.0001 0.299988C11.8226 0.299988 13.3001 1.77745 13.3001 3.59999Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8001 5.79999C18.8001 7.01501 17.8151 7.99999 16.6001 7.99999C15.3851 7.99999 14.4001 7.01501 14.4001 5.79999C14.4001 4.58496 15.3851 3.59999 16.6001 3.59999C17.8151 3.59999 18.8001 4.58496 18.8001 5.79999Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4001 13.5C14.4001 11.0699 12.4301 9.09999 10.0001 9.09999C7.57004 9.09999 5.60009 11.0699 5.60009 13.5V16.8H14.4001V13.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60009 5.79999C5.60009 7.01501 4.61512 7.99999 3.4001 7.99999C2.18507 7.99999 1.2001 7.01501 1.2001 5.79999C1.2001 4.58496 2.18507 3.59999 3.4001 3.59999C4.61512 3.59999 5.60009 4.58496 5.60009 5.79999Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6001 16.8V13.5C16.6001 12.3404 16.3011 11.2507 15.7759 10.3037C16.0393 10.236 16.3155 10.2 16.6001 10.2C18.4226 10.2 19.9001 11.6774 19.9001 13.5V16.8H16.6001Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22428 10.3037C3.69913 11.2507 3.4001 12.3404 3.4001 13.5V16.8H0.100098V13.5C0.100098 11.6774 1.57756 10.2 3.4001 10.2C3.68468 10.2 3.96084 10.236 4.22428 10.3037Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.4537300923cc521811383c855e612e59.svg";
export { ForwardRef as ReactComponent };